import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from 'prop-types';

const ReusableSnackbar = ({ open, handleClose, message, severity = 'success', duration = 6000 }) => {
  return (
    <Snackbar open={open} autoHideDuration={duration} onClose={handleClose}>
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

ReusableSnackbar.propTypes = {
  open: PropTypes.any,
  handleClose: PropTypes.any,
  message: PropTypes.any,
  severity: PropTypes.any,
  duration: PropTypes.any,
};

export default ReusableSnackbar;
